import React, { useState, useEffect } from 'react';
import { CirclePicker } from 'react-color';
// Removed Col, Row imports
import { CBCheckItem } from '../../core/components/cbd';

const CompactColorPicker = ({ type, color="default", onColorChangeCallback, preview=false }) => {
    const [pickedColor, setPickedColor] = useState("#fff");
    
    const msColors = [
        "#ffff00", // Yellow
        "#ff0000", // Red
        "#800080", // Purple
        "#ffa500", // Orange
        "#008000", // Green
        "#0000ff"  // Blue
    ];
    
    const msMapping = [
        "Yellow category",
        "Red category",
        "Purple category",
        "Orange category",
        "Green category",
        "Blue category"
    ];
   
    const googleColors = [
        "#a4bdfc",
        "#7ae7bf",
        "#dbadff",
        "#ff887c",
        "#fbd75b",
        "#ffb878",
        "#46d6db",
        "#e1e1e1",
        "#5484ed",
        "#51b749",
    ];
    
    const calendarType = type;
    
    useEffect(() => {
        if (color !== 'default' && pickedColor === '#fff') {
            let colorPicked = '#fff';
            if (calendarType === "ms" || calendarType === "ews") {
                const idx = msMapping.indexOf(color);
                if (idx === -1) {
                    colorPicked = 'default';
                } else {
                    colorPicked = msColors[idx];
                }
            } else {
                colorPicked = googleColors[color-1];
            }
            setPickedColor(colorPicked);
        } else if (color === 'default' && pickedColor === '#fff') {
            setPickedColor('default');
        }
    }, [color, calendarType, pickedColor]);

    function colorChange(color) {
        setPickedColor(color.hex);

        if (calendarType === "ms" || calendarType === "ews") {
            const index = msColors.indexOf(color.hex);
            onColorChangeCallback(index !== -1 ? msMapping[index] : msMapping[0]);
        } else {
            const index = googleColors.indexOf(color.hex);
            onColorChangeCallback(`${index + 1}`);
        }
    }
    
    const colors = !preview 
        ? ((calendarType === "ms" || calendarType === "ews") ? msColors : googleColors) 
        : ((calendarType === "ms" || calendarType === "ews") 
            ? [msMapping.indexOf(color) !== -1 ? msColors[msMapping.indexOf(color)] : '#fff'] 
            : [googleColors[parseInt(color)-1]]);

    return (
        <div className="compact-color-picker">
            {!preview && (
                <div className="flex flex-col">
                    <div className="mb-1">
                        <CirclePicker 
                            color={pickedColor} 
                            colors={colors} 
                            onChangeComplete={colorChange}
                            circleSize={16}
                            circleSpacing={6}
                            width="100%"
                        />
                    </div>
                    <div>
                        <CBCheckItem 
                            onChange={(checked) => {
                                if (checked) {
                                    setPickedColor('default');
                                    onColorChangeCallback('default');
                                } else {
                                    // When unchecking, set to the first color in the palette
                                    const firstColor = colors[0];
                                    setPickedColor(firstColor);
                                    
                                    // Call the callback with the appropriate format based on calendar type
                                    if (calendarType === "ms" || calendarType === "ews") {
                                        const index = msColors.indexOf(firstColor);
                                        onColorChangeCallback(index !== -1 ? msMapping[index] : msMapping[0]);
                                    } else {
                                        const index = googleColors.indexOf(firstColor);
                                        onColorChangeCallback(`${index + 1}`);
                                    }
                                }
                            }}
                            checked={pickedColor === 'default'}
                            label="Calendar Default"
                            color="#B85614"
                        />
                    </div>
                </div>
            )}
            {preview && (
                <div className="flex justify-center">
                    <CirclePicker 
                        colors={colors} 
                        circleSize={14} 
                        circleSpacing={4}
                        width="auto"
                    />
                </div>
            )}
        </div>
    );
};

export default CompactColorPicker;
